import { CallbackType } from '@forgerock/javascript-sdk';
import {
  updateOTPRequestedState,
  updateOtpCountAction,
  updateErrorCode,
  updateBackupEmailOrNumberAdded,
} from 'components/Login/actions';
import { checkStep } from 'utils/authTree/helpers';
import { getCallbackOfTypeSafely, getCallbackWithMessageSafely } from '../authTreeUtils';
import { ADD_NUMBER_OR_BACKUP_EMAIL, GO_BACK_SELECTION, INVALID_OTP } from './constants';
import executeHiddenCallbackForOTPAutomatedTesting from './executeHiddenCallbackForOTPAutomatedTesting';
import nextStep from './handleStep';
import { MESSAGE_BACKUP_EMAIL_INVALID } from 'components/Login/constants';
import { mapErrorFromJson } from 'utils/error-map';

const addBackupEmailbackButton = 'ciam.addBackupEmailbackButton-otp';
const addNumberbackButton = 'ciam.addNumberbackButton-otp';

export const addBackupEmailOrNumberAsyncAction = async (dispatch, payload, type) => {
  dispatch(updateErrorCode(null));
  let backButton = addNumberbackButton;
  let redirectUrl = '/addnumbermfa';
  if (type === 'backupEmail') {
    backButton = addBackupEmailbackButton;
    redirectUrl = '/addbackupemailmfa';
  }
  sessionStorage.removeItem('ciam.backButton-otp');
  sessionStorage.removeItem(backButton);
  const { stage, backupEmailOrNumber, history } = payload;
  dispatch(updateOtpCountAction(0));
  dispatch(updateBackupEmailOrNumberAdded(true, backupEmailOrNumber, type));
  dispatch(updateOTPRequestedState(false));
  let step = '';
  let resultStep = '';
  const passwordCallback = getCallbackOfTypeSafely(stage, CallbackType.PasswordCallback);
  if (passwordCallback) {
    passwordCallback.setPassword(INVALID_OTP);
    step = await nextStep(dispatch, stage);

    const choiceCallback = getCallbackOfTypeSafely(step, CallbackType.ChoiceCallback);
    if (choiceCallback) {
      choiceCallback.setChoiceIndex(GO_BACK_SELECTION);
      step = await nextStep(dispatch, step);
    }
  }
  step = step === '' ? stage : step;
  const nameCallback = getCallbackOfTypeSafely(step, CallbackType.NameCallback);
  if (nameCallback) {
    nameCallback.setName(backupEmailOrNumber);
    const secondStep = await nextStep(dispatch, step);
    if (getCallbackOfTypeSafely(secondStep, CallbackType.PasswordCallback)) {
      dispatch(updateOTPRequestedState(true));
    }
    resultStep = await executeHiddenCallbackForOTPAutomatedTesting(dispatch, secondStep);
  } else if (getCallbackOfTypeSafely(step, CallbackType.TextOutputCallback)) {
    const confirmationCallback = step.getCallbackOfType(CallbackType.ConfirmationCallback);
    confirmationCallback.setInputValue(ADD_NUMBER_OR_BACKUP_EMAIL);
    step = await nextStep(dispatch, stage);

    const nextStepNameCallback = getCallbackOfTypeSafely(step, CallbackType.NameCallback);
    if (nextStepNameCallback) {
      nextStepNameCallback.setName(backupEmailOrNumber);
      const secondStep = await nextStep(dispatch, step);
      resultStep = await executeHiddenCallbackForOTPAutomatedTesting(dispatch, secondStep);
    } else {
      // handle any uncaught error - request not sent from UI
      checkStep(step, 'D_705');
    }
  } else {
    // nothing to do
  }
  if (getCallbackOfTypeSafely(resultStep, CallbackType.PasswordCallback)) {
    // store stage-info in local storage to fetch again for back button purposes
    sessionStorage.setItem(backButton, JSON.stringify(resultStep));
    dispatch(updateOTPRequestedState(true));
    history.push(redirectUrl);
  } else if (getCallbackWithMessageSafely(resultStep, MESSAGE_BACKUP_EMAIL_INVALID)) {
    dispatch(updateErrorCode(mapErrorFromJson('D_637')));
  } else {
    // handle any uncaught error - request not sent from UI
    checkStep(null, 'D_705');
  }
};

export default addBackupEmailOrNumberAsyncAction;
